// no dangerouslySetInnerHTML — titles are user-controlled text (SEC-REQ-4)
//
// V2 source path: customer/midas/components/v2/history/MidasHistorySkeletonV2.tsx
// V1 source: none (greenfield — Phase 4)
// Strategy: scratch
// Verified no-MUI: yes
// Phase: 4 — sub-phase 4.4a (matches new hairline row shape)
//
// Loading skeleton for the history page list. Shows 8 shimmer rows that
// match the new hairline row anatomy (4-column grid, no card, hairline
// bottom). Without this update the load state would jolt visually when
// the real rows render in their new shape.
import React from "react";

const MidasHistorySkeletonV2: React.FC = () => (
  <div
    role="status"
    aria-label="Loading conversations"
    className="flex flex-col gap-4 px-1 pt-3"
  >
    {/* Date-group eyebrow placeholder */}
    <div
      className="h-3 w-20 animate-pulse rounded bg-midas-warm-stone"
      aria-hidden="true"
    />
    {/* Row stack — hairline rows (no gap, edge-to-edge with bottom border).
        Mirrors MidasHistoryRowV2 layout: time col 64 + title flex + pill
        + arrow. */}
    <ul className="m-0 flex list-none flex-col p-0">
      {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
        <li
          key={i}
          className="flex w-full items-start gap-4 border-b border-solid border-[#EBE5D9] px-3 py-3.5"
          aria-hidden="true"
        >
          {/* Time col */}
          <div className="flex w-16 flex-shrink-0 flex-col items-start gap-1.5 pt-0.5">
            <div className="h-2.5 w-10 animate-pulse rounded bg-midas-warm-stone" />
            <div className="h-2 w-8 animate-pulse rounded bg-midas-warm-stone/70" />
          </div>
          {/* Title + snippet */}
          <div className="flex min-w-0 flex-grow flex-shrink basis-0 flex-col gap-2">
            <div className="h-3 w-3/5 animate-pulse rounded bg-midas-warm-stone" />
            <div className="h-2.5 w-4/5 animate-pulse rounded bg-midas-warm-stone/70" />
          </div>
          {/* Machine pill placeholder */}
          <div className="mt-0.5 h-5 w-20 flex-shrink-0 animate-pulse self-start rounded-full bg-midas-warm-stone/70" />
          {/* Arrow placeholder */}
          <div
            className="h-3 w-3 flex-shrink-0 animate-pulse rounded bg-midas-warm-stone/50"
            style={{ marginTop: 4 }}
          />
        </li>
      ))}
    </ul>
  </div>
);

export default MidasHistorySkeletonV2;
